import { render, staticRenderFns } from "./InsCurrentTab1.vue?vue&type=template&id=06220708&scoped=true&"
import script from "./InsCurrentTab1.vue?vue&type=script&lang=ts&"
export * from "./InsCurrentTab1.vue?vue&type=script&lang=ts&"
import style0 from "./InsCurrentTab1.vue?vue&type=style&index=0&lang=less&"
import style1 from "./InsCurrentTab1.vue?vue&type=style&index=1&id=06220708&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06220708",
  null
  
)

export default component.exports